export var ENDPOINTS = {
  accountsEndpoint: '/api/uni-profile/accounts/',
  initData: '/api/uni-profile/page-init-data/',
  fetchSideMenuData: '/api/texts/?key=side-menu-data',
  notAuthData: '/api/texts/curtain-icon',
  notifications: '/api/uni-profile-context/',
  fetchBalance: '/apigw/ub/balance/main/',
  fetchBalances: '/apigw/ub/balance/all/',
  fetchFubGroups: '/apigw/fub/group/light/',
  mobileConnectionBlock: '/api/uni-profile-mobile/blocks/',
  mobileConnectionPrice: '/api/uni-profile-mobile/tariff-fee/',
  mobileConnectionBlockTariffUpPower: '/api/uni-profile-mobile/powers/passive/',
  mobileConnectionBlockTariffUpSuperPower: '/api/uni-profile-mobile/powers/active/',
  fttbTariff: '/api/uni-profile-fttb/tariff/info/',
  mainHome: '/api/uni-profile-fttb/'
};
export var USER_TYPE = {
  FTTB: 'fttb',
  CONVERGENT: 'convergent',
  MOBILE: 'mobile'
};
export var NOTIFICATION_TYPE = {
  invite: 'Invite',
  link: 'Link',
  payment: 'FinBlock',
  //  from specs
  unknown: 'Unknown',
  pcl: 'Pcl',
  sos: 'SosPackage',
  replaceSim: 'ReplaceSim',
  passportData: 'PassportData',
  fz533: 'FZ533',
  simplification: 'Simplification',
  userBlock: 'UserBlock',
  IPOE: 'IPOE',
  adminBlock: 'AdminBlock',
  collection: 'Collection',
  relocation: 'FttbRelocation',
  promisedPayment: 'FttbPromisedPayment',
  userBlockPlanned: 'FttbUserBlockPlanned'
};